<template>
  <div
    v-if="show"
    class="loading-overlay"
    :class="{ fullscreen: fullscreen }"
  >
    <div class="loading-container">
      <svg
        width="126"
        height="125"
        viewBox="0 0 126 125"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="logo-path path-1"
          d="M50.2075 0L51.34 0.3775L44.545 3.3975L38.505 6.795L34.3525 9.815L30.955 12.835L30.5691 13.2041L30.2 13.59L25.67 18.12L21.14 24.5375L17.7425 30.955L15.1 38.1275L13.59 44.545L12.835 49.83V59.2675L13.9675 66.8175L15.4775 72.48L18.4975 80.03L21.895 86.07L25.2925 90.6L28.69 94.375L32.465 98.15L37.3725 101.925L43.035 105.323L49.83 108.342L55.87 110.23L64.175 111.74H75.5L82.6725 110.607L89.09 108.72L95.885 105.7L100.037 103.435L106.455 98.905L111.363 94.375L114.76 90.2225L118.158 85.6925L121.177 80.4075L124.198 72.8575L124.952 70.215H125.33L124.952 74.3675L122.688 82.295L119.667 89.845L115.515 97.0175L111.74 101.925L107.588 106.455L104.567 109.475L98.15 114.382L90.2225 118.912L84.56 121.177L76.6325 123.442L69.8375 124.575H56.2475L49.4525 123.442L43.79 121.933L37.75 119.667L31.71 116.647L27.5575 114.005L22.65 110.23L18.12 106.077L14.7225 102.68L10.1925 96.2625L6.4175 89.845L3.3975 82.6725L1.8875 77.765L0.3775 69.46L0 65.3075V58.5125L0.755 51.34L2.6425 43.4125L5.285 36.24L9.06 29.0675L13.2125 23.0275L17.7425 17.7425L22.2725 13.59L27.18 9.815L32.8425 6.4175L38.8825 3.3975L46.81 0.755L50.2075 0Z"
          fill="#0097DA"
        />
        <path
          class="logo-path path-2"
          d="M83.805 32.4651H92.865L99.2825 34.3526L104.567 37.3726L109.097 41.5251L111.74 45.3001L114.382 50.5851L115.515 55.4926V64.1751L114.005 69.4601L110.985 75.5001L106.832 80.0301L104.19 82.2951L100.415 84.5601L94.7525 86.4476L89.845 87.2026H86.4475L80.4075 86.0701L75.5 84.1826L71.3475 81.5401L67.5725 78.1426L64.175 73.2351L62.2875 68.7051L61.155 64.5526L60.7775 58.1351L61.5325 53.2276L63.0425 48.6976L64.93 44.9226L67.5725 41.5251L71.3475 37.7501L76.6325 34.7301L81.9175 32.8426L83.805 32.4651Z"
          fill="#263844"
        />
        <path
          class="logo-path path-3"
          d="M67.1949 0.377563H76.6324L85.6924 1.88756L92.1099 4.15256L98.1499 7.17256L101.925 9.43756L100.792 9.81506L95.1299 7.55006L89.0899 6.04006L83.0499 5.28506H77.3874L69.4599 6.41756L61.9099 8.68256L55.8699 11.7026L51.7174 14.3451L47.5649 17.7426L44.1674 21.1401L40.0149 26.4251L36.6174 32.4651L34.3524 38.1276L32.8424 44.1676L32.0874 50.2076V56.6251L32.8424 62.6651L34.7299 69.8376L36.6174 74.3676L39.2599 79.2751L43.7899 85.3151L49.0749 90.6001L54.3599 94.3751L60.7774 97.7726L67.5724 100.038L73.2349 101.17L76.6324 101.548H83.4274L91.3549 100.415L97.3949 98.5276L101.925 96.6401L102.68 97.0176L99.2824 99.2826L91.3549 103.435L83.8049 105.7L76.6324 106.833H67.1949L59.6449 105.7L53.2274 103.813L46.0549 100.415L40.7699 97.0176L36.9949 93.9976L32.8424 90.2226L29.4449 86.0701L26.8024 82.2951L23.7824 77.0101L21.5174 71.3476L19.6299 64.9301L18.8749 60.4001L18.4974 56.2476V50.5851L19.6299 42.2801L21.8949 34.7301L24.9149 27.9351L28.3124 22.6501L31.3324 18.8751L34.7299 15.1001L39.6374 10.9476L45.2999 7.17256L53.2274 3.39756L59.6449 1.51006L67.1949 0.377563Z"
          fill="#0A77AC"
        />
        <path
          class="logo-path path-4"
          d="M77.0099 9.81506H86.0699L93.6199 11.3251L99.6599 13.5901L104.19 15.8551L109.475 19.6301L113.25 23.0276L116.647 27.1801L120.045 32.4651L122.687 38.1276L124.197 43.0351L124.575 46.4326L123.82 45.3001L121.177 39.2601L117.78 33.9751L114.382 30.2001L111.74 27.5576L106.077 23.7826L100.037 21.1401L95.1299 19.6301L90.2224 18.8751H82.6724L76.2549 20.0076L69.0824 22.6501L63.7974 25.6701L59.6449 29.0676L55.8699 32.8426L52.0949 38.5051L49.8299 43.0351L47.9424 49.0751L47.1874 53.6051V63.0426L48.3199 69.0826L50.9624 76.2551L54.7374 82.2951L59.2674 87.2026L63.7974 90.9776L69.8374 94.3751L74.7449 96.2626V96.6401L70.9699 96.2626L64.1749 93.9976L57.0024 90.2226L52.8499 86.8251L47.5649 81.5401L43.7899 76.2551L40.7699 70.2151L38.5049 62.6651L37.7499 57.3801V49.8301L38.8824 43.0351L40.7699 36.9951L43.7899 30.9551L47.5649 25.6701L51.7174 21.1401L57.0024 16.9876L63.0424 13.5901L69.4599 11.3251L77.0099 9.81506Z"
          fill="#225A7C"
        />
      </svg>
      <div class="loading-text">{{ text }}</div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  text: {
    type: String,
    default: 'Cargando...',
  },
  fullscreen: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped>
/* Loading Overlay */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(3px);
  margin-left: 64px; /* Ancho del sidebar */
}

.loading-overlay.fullscreen {
  margin-left: 0; /* Cubrir toda la pantalla incluyendo el sidebar */
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.loading-text {
  font-size: 18px;
  font-weight: 600;
  color: #0097da;
  animation: textPulse 1s ease-in-out infinite;
}

/* Text Animation */
@keyframes textPulse {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

/* Pulso suave para el círculo central - igual que el texto */
@keyframes centerPulse {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

/* Path Animations - Configuración base */
.logo-path {
  transform-origin: center;
  opacity: 0;
}

/* Animación solo de aparición (para el círculo central) */
@keyframes fadeInStay {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  20% {
    opacity: 1;
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* Path 2 - Círculo Central - Aparece primero y permanece siempre */
.path-2 {
  animation:
    fadeInStay 0.3s ease-out forwards,
    centerPulse 1s ease-in-out 0.3s infinite;
}

/* Animación personalizada para cada path */
/* Duración total del ciclo: 2 segundos para todos (velocidad aumentada) */
/* 0s-0.15s: Path4 aparece */
/* 0.15s-0.3s: Path3 aparece */
/* 0.3s-0.45s: Path1 aparece */
/* 0.45s-1.2s: Todos visibles (0.75s de pausa) */
/* 1.2s-1.35s: Path1 desaparece */
/* 1.35s-1.5s: Path3 desaparece */
/* 1.5s-1.65s: Path4 desaparece */
/* 1.65s-2.0s: Solo Path2 visible */

/* Path 1 - Aparece último (0.3s-0.45s), desaparece primero (1.2s-1.35s) */
.path-1 {
  animation: path1Animation 2s ease-in-out infinite;
}

@keyframes path1Animation {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  15% {
    /* 0.3s */
    opacity: 0;
    transform: scale(0.8);
  }
  22.5% {
    /* 0.45s */
    opacity: 1;
    transform: scale(1);
  }
  60% {
    /* 1.2s */
    opacity: 1;
    transform: scale(1);
  }
  67.5% {
    /* 1.35s */
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 0;
    transform: scale(0.8);
  }
}

/* Path 3 - Aparece segundo (0.15s-0.3s), desaparece segundo (1.35s-1.5s) */
.path-3 {
  animation: path3Animation 2s ease-in-out infinite;
}

@keyframes path3Animation {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  7.5% {
    /* 0.15s */
    opacity: 0;
    transform: scale(0.8);
  }
  15% {
    /* 0.3s */
    opacity: 1;
    transform: scale(1);
  }
  67.5% {
    /* 1.35s */
    opacity: 1;
    transform: scale(1);
  }
  75% {
    /* 1.5s */
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 0;
    transform: scale(0.8);
  }
}

/* Path 4 - Aparece primero (0s-0.15s), desaparece último (1.5s-1.65s) */
.path-4 {
  animation: path4Animation 2s ease-in-out infinite;
}

@keyframes path4Animation {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  7.5% {
    /* 0.15s */
    opacity: 1;
    transform: scale(1);
  }
  75% {
    /* 1.5s */
    opacity: 1;
    transform: scale(1);
  }
  82.5% {
    /* 1.65s */
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 0;
    transform: scale(0.8);
  }
}
</style>
